import { render, staticRenderFns } from "./ListSalesOrder.vue?vue&type=template&id=bca66018"
import script from "./ListSalesOrder.vue?vue&type=script&lang=js"
export * from "./ListSalesOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListSalesOrder.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bca66018')) {
      api.createRecord('bca66018', component.options)
    } else {
      api.reload('bca66018', component.options)
    }
    module.hot.accept("./ListSalesOrder.vue?vue&type=template&id=bca66018", function () {
      api.rerender('bca66018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListSalesOrder.vue"
export default component.exports